import { createClient, SupabaseClient } from '@supabase/supabase-js'

function getSupabaseConfig() {
  let supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
  let supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

  if ((!supabaseUrl || !supabaseAnonKey) && typeof window !== 'undefined') {
    const windowEnv = (window as { __ENV__?: Record<string, string> }).__ENV__
    if (windowEnv) {
      supabaseUrl = windowEnv.VITE_SUPABASE_URL || supabaseUrl
      supabaseAnonKey = windowEnv.VITE_SUPABASE_ANON_KEY || supabaseAnonKey
    }

    const config = (window as { __SUPABASE_CONFIG__?: Record<string, string> }).__SUPABASE_CONFIG__
    if ((!supabaseUrl || !supabaseAnonKey) && config) {
      supabaseUrl = config.url || config.VITE_SUPABASE_URL || supabaseUrl
      supabaseAnonKey = config.anonKey || config.VITE_SUPABASE_ANON_KEY || supabaseAnonKey
    }
  }

  return { supabaseUrl, supabaseAnonKey }
}

function validateSupabaseUrl(url: string): boolean {
  if (!url) return false
  return url.startsWith('https://') && (url.includes('.supabase.co') || url.includes('supabase'))
}

const { supabaseUrl, supabaseAnonKey } = getSupabaseConfig()
const isPlaceholderUrl = supabaseUrl === 'https://placeholder.supabase.co' || supabaseUrl === ''
const isPlaceholderKey = supabaseAnonKey === 'placeholder-key' || supabaseAnonKey === ''
const isValidUrl = supabaseUrl && validateSupabaseUrl(supabaseUrl)
const isProduction = import.meta.env.PROD

if (!isProduction) {
  if (!supabaseUrl || !supabaseAnonKey || isPlaceholderUrl || isPlaceholderKey || !isValidUrl) {
    console.error('❌ Supabase environment variables are not set or invalid!')
  }
}

export function createSupabaseClient(storageKey?: string): SupabaseClient {
  const auth: {
    autoRefreshToken: boolean
    persistSession: boolean
    detectSessionInUrl: boolean
    flowType: 'implicit'
    storageKey?: string
  } = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
  }

  if (storageKey) {
    auth.storageKey = storageKey
  }

  return createClient(
    supabaseUrl || 'https://placeholder.supabase.co',
    supabaseAnonKey || 'placeholder-key',
    { auth },
  )
}
